import React from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { visNavDataModel } from './dataModel';
import { VisualNavigationRenderer } from './VisualNavigationRenderer';

const VisualNavigation = ({
  componentId,
  componentClass = '',
  componentPosition = 1,
  isInSection = false,
  lazyLoad = false,
  experienceHasSideNav = false,
  enableTheme = false,
  fontWeight = 'display',
  enableHomepageGap = false,
  enableB2CRadius = false,
  enableFullBleed = false,
  showInternalTitle = true
}) => {
  const { data, loading, error } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass: 'VisualNavigation'
    }
  });

  if (!data || loading || error) {
    return null;
  }

  return (
    <VisualNavigationRenderer
      componentId={componentId}
      componentPosition={componentPosition}
      componentClass={componentClass}
      isInSection={isInSection}
      lazyLoad={lazyLoad}
      experienceHasSideNav={experienceHasSideNav}
      dataComponent={data?.component}
      visNavList={data?.component?.visualNavigationList}
      displayName={VisualNavigation.displayName}
      enableTheme={enableTheme}
      fontWeight={fontWeight}
      enableHomepageGap={enableHomepageGap}
      enableB2CRadius={enableB2CRadius}
      enableFullBleed={enableFullBleed}
      showInternalTitle={showInternalTitle}
    />
  );
};
VisualNavigation.displayName = 'VisualNavigation';
VisualNavigation.propTypes = {
  componentId: PropTypes.string.isRequired,
  componentClass: PropTypes.string,
  componentPosition: PropTypes.number,
  isInSection: PropTypes.bool,
  lazyLoad: PropTypes.bool,
  experienceHasSideNav: PropTypes.bool,
  enableTheme: PropTypes.bool,
  fontWeight: PropTypes.string,
  enableHomepageGap: PropTypes.bool,
  enableB2CRadius: PropTypes.bool,
  enableFullBleed: PropTypes.bool,
  showInternalTitle: PropTypes.bool,
};

VisualNavigation.dataModel = visNavDataModel;

export { VisualNavigation };
